import { render, staticRenderFns } from "./CheckboxGroupInputBlock.vue?vue&type=template&id=e71fe6f6"
import script from "./CheckboxGroupInputBlock.vue?vue&type=script&lang=ts"
export * from "./CheckboxGroupInputBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports